import React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import classnames from 'classnames';

import ErrorPage from '@components/ErrorPage';
import Loading from '@components/Loading';

import PaymentLandingPage from '../PaymentLandingPage';

import './style.scss';

interface IPaymentPortalAppProps extends RouteComponentProps<{}> {
  loadingComponents: number;
}

class PaymentPortalApp extends React.PureComponent<IPaymentPortalAppProps> {
  constructor(props: IPaymentPortalAppProps) {
    super(props);
  }

  render() {
    return (
      <div className={classnames('payment-portal-app')}>
        <Switch>
          <Route exact path="/payment-portal/error" component={ErrorPage} />
          <Route exact path="/payment-portal/:portalToken" component={PaymentLandingPage} />
        </Switch>
        <Loading show={this.props.loadingComponents > 0} />
      </div>
    );
  }
}

const mapStateToProps = (state: IReduxStore) => ({
  loadingComponents: state.appState.loadingComponents,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentPortalApp));
